import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useArtistAuth } from '../hooks/useArtistAuth';
import LoadingSpinner from './ui/LoadingSpinner';

const ProtectedArtistRoute = ({ children }) => {
  const { user, isArtist, loading } = useArtistAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <LoadingSpinner />
          <p className="mt-4 text-gray-600">Checking authentication...</p>
        </div>
      </div>
    );
  }

  if (!user || !isArtist) {
    // Redirect to login with the current location to return after login
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedArtistRoute;
